module.exports = __webpack_public_path__ + "static/media/README.a22b7e36.md";